import * as React from 'react';

import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import { Primitive } from '@rtkwlf/fenrir-react';

export type WrapperProps = {
  className?: string;
  wrapperStyle?: SerializedStyles;
};

export const Wrapper = (props: React.PropsWithChildren<WrapperProps>) => {
  const { children, wrapperStyle, className = '' } = props;

  return (
    <Primitive.div
      className={className}
      boxShadow="default"
      backgroundColor="widgetDefault"
      borderRadius="default"
      overflow="auto"
      css={css`
        ${wrapperStyle}
      `}
    >
      {children}
    </Primitive.div>
  );
};
